import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

import { StatCard } from '@/shared/ui';
import type { StatsData } from '../../model/types';

interface StockOnHandStatsProps {
  stats: StatsData | null;
  isLoading: boolean;
}

export function StockOnHandStats({ stats, isLoading }: StockOnHandStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <StatCard label={t('report.type.soh.label', 'Current Stock')} value={stats?.totalVolume} isLoading={isLoading} />
      <StatCard
        label={t('report_storageOverview_soh_expiringSoonLabel', 'Expiring Soon')}
        value={stats?.expiringSOH}
        variant="warning"
        isLoading={isLoading}
      />
      <StatCard
        label={t('report_storageOverview_soh_longStandingLabel', 'Long Standing')}
        value={
          <div className="flex items-center gap-2">
            <span className="text-2xl font-semibold">{stats?.longStandingPerc}</span>
            <Badge variant="secondary">90+ days</Badge>
          </div>
        }
        isLoading={isLoading}
      />
      <StatCard
        label={t('report_storageOverview_soh_issuesLabel', 'Issues')}
        value={
          <div className="text-sm font-medium space-y-1">
            <div className="text-destructive">Lost: {stats?.lossTotal}</div>
            <div className="text-orange-600">Damaged: {stats?.damageTotal}</div>
          </div>
        }
        isLoading={isLoading}
      />
    </div>
  );
}
